import { createContext } from 'react';
import { DocumentResponse, HandoverPackSectionResponse, PartResponse } from '../documentResponse';

export type HandoverPackSectionContextValue = {
  allDocuments: Array<DocumentResponse>;
  handoverPackSections: Array<HandoverPackSectionResponse>;
  parts: Array<PartResponse>;
  refreshContext: () => void;
};

export const HandoverPackSectionContext = createContext<HandoverPackSectionContextValue>({
  allDocuments: [],
  handoverPackSections: [],
  parts: [],
  refreshContext: () => {
    throw new Error('Document Context has not been initialised yet');
  },
});
